import React from "react";
import { makeStyles } from "@mui/styles";
import { Grid, Hidden, Typography } from "@mui/material";
import { SIDE_PADDING, TOP_PADDING } from "../../../app/theme/muiTheme";

const usestyles = makeStyles((theme) => ({
  root: {
    paddingTop: TOP_PADDING,
    paddingBottom: SIDE_PADDING,
    paddingLeft: SIDE_PADDING,
    paddingRight: SIDE_PADDING,
    backgroundColor: theme.palette.primary.main,
    [theme.breakpoints.down("md")]: {
      paddingTop: "10%",
    },
  },
  abouttxt: {
    fontWeight: "bold",
    fontSize: 72,
    [theme.breakpoints.down("md")]: {
      fontSize: 30,
      fontWeight: "normal",
    },
  },
  aboutdesctxt: {
    fontSize: "2.0rem",
    [theme.breakpoints.down("md")]: {
      fontSize: 18,
    },
  },
  aboutlongdesctxt: {
    fontSize: "1.1rem",
    [theme.breakpoints.down("md")]: {
      fontSize: 14,
    },
  },
  profileimg: {},
}));

const AboutMe = (props) => {
  const classes = usestyles();
  return (
    <div className={classes.root}>
      <Grid container>
        <Hidden mdDown>
          <Grid item xs={12} md={4}>
            <Typography className={classes.abouttxt}>
              ABOUT
              <br />
              ME
            </Typography>
          </Grid>
        </Hidden>
        <Hidden mdUp>
          <Grid item xs={12}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <img
                alt="profile"
                className={classes.profileimg}
                src="/images/profilesm.svg"
              />
              <Typography className={classes.abouttxt}>
                &nbsp;&nbsp;&nbsp;About Me
              </Typography>
            </div>
          </Grid>
        </Hidden>
        <Grid item xs={12} md={6}>
          <Hidden mdUp>
            <br />
          </Hidden>
          <Typography className={classes.aboutdesctxt}>
            "For a lawyer, there is no better engagement than fighting for
            upholding of righteousness."
          </Typography>
        </Grid>
      </Grid>
      <Grid container style={{ paddingTop: "3%" }}>
        <Hidden mdDown>
          <Grid item xs={4}>
            <img
              alt="profile"
              className={classes.profileimg}
              src="/images/profile.svg"
            />
          </Grid>
        </Hidden>
        <Grid item xs={12} md={6}>
          <Typography className={classes.aboutlongdesctxt}>
            I am a lawyer. My journey from being a professional engineer to
            being a legal professional has been for a purpose and I am working
            to bring changes in law, through my advocacy, for the betterment of
            our own society. I am working to eradicate gender inequality and I
            have taken initiatives for the same. The founding principle of my
            work is to fight for justice. Considering my duty as a lawyer,
            nothing wavers me. Afterall, for a lawyer, there is no better
            engagement than fighting for upholding of righteousness.
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
};

export default AboutMe;
